import pxToRem from '../theme/pxToRem';

const styleOverrides = {
  root: {
    height: 32,
    borderRadius: 32 / 2,
    '& .MuiChip-icon': {
      fontSize: pxToRem(24),
      marginRight: -6,
      marginLeft: 5,
    },
    '& .MuiChip-deleteIcon': {
      fontSize: pxToRem(22),
      marginLeft: -6,
      marginRight: 5,
    },

    '& > img:first-of-type, & .MuiChip-avatar': {
      width: 20,
      height: 20,
      marginLeft: 7,
      marginRight: -4,
    },
  },
  sizeSmall: {
    height: 24,
    '& .MuiChip-icon, & .MuiChip-avatar': {
      fontSize: pxToRem(18),
      marginRight: -4,
      marginLeft: 6,
    },
    '& .MuiChip-deleteIcon': {
      fontSize: pxToRem(16),
      marginLeft: -4,
      marginRight: 6,
    },
    '& > img:first-of-type': {
      width: 16,
      height: 16,
      marginLeft: 5,
      marginRight: -3,
    },
  },
  label: {
    paddingLeft: 12,
    paddingRight: 12,
  },
  labelSmall: {
    paddingLeft: 8,
    paddingRight: 8,
  },
};

export default styleOverrides;
